import { FC, useMemo } from 'react';
import { MoTableData } from 'ts/shared/interfaces/MOResponse';
import { getStatus } from 'constants/mo';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from '../withErrorBoundary';

interface MoStatisticsProps {
  tableData: MoTableData[];
}

const MoStatistics: FC<MoStatisticsProps> = ({ tableData }) => {
  const segmentsCount = tableData.length;
  const { t } = useTranslation();

  const ordersCount = useMemo(() => {
    return tableData.reduce((acc, it) => acc + it.quantity, 0);
  }, [tableData]);
  const statusCounts = useMemo(() => {
    const statuses = Object.values(
      tableData.reduce((acc, item) => {
        const status = item.status;
        if (!acc[status]) {
          acc[status] = { label: status, count: 0 };
        }
        acc[status].count++;
        return acc;
      }, {} as Record<string, { label: string; count: number }>)
    );
    return statuses.sort((a, b) => b.count - a.count);
  }, [tableData]);

  return (
    <span className="text-xxs mr-10">
      <span className="text-bold">
        {t('mo.items')} {segmentsCount}
      </span>
      <span className="text-bold ph-5">|</span>
      <span className="text-bold">
        {t('mo.units')} {ordersCount}
      </span>
      <span className="mo-status-wr">
        <span className="text-bold ph-5">|</span>
        {statusCounts.map((item, index) => (
          <span key={item.label}>
            <span className={`mo-status ${getStatus(item.label)}`}>{item.label}</span> -{' '}
            {item.count}
            {index < statusCounts.length - 1 && <span className="ph-5 text-bold">|</span>}
          </span>
        ))}
      </span>
    </span>
  );
};

export default withErrorBoundary(MoStatistics, 'MoStatistics');
